import { prop, compose } from 'ramda';
import type { RoutingState } from '@peloton/redux';
import { getQueryParams } from '@peloton/redux';
import { CLASS_ID_PARAM } from './constants';

export const getClassIdFromLocation = compose<
  RoutingState,
  Record<string, string>,
  string
>(prop(CLASS_ID_PARAM), getQueryParams);
